var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommentHollow = function SvgCommentHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.012 2.473c-4.582 0-8.334 3.334-8.334 7.5 0 1.31.369 2.583 1.068 3.698.376.599.411 1.451-.156 2.604a.838.838 0 0 0 .677 1.198c1.13.108 2.086-.082 3.385-.625a9.4 9.4 0 0 0 3.36.625c4.582 0 8.333-3.335 8.333-7.5 0-4.166-3.751-7.5-8.333-7.5m0 1.667c3.702 0 6.666 2.635 6.666 5.833s-2.964 5.833-6.666 5.833a7.4 7.4 0 0 1-3.021-.624.84.84 0 0 0-.677 0c-.767.335-1.201.519-1.771.599.316-1.088.084-2.24-.39-2.995a5.27 5.27 0 0 1-.808-2.813c0-3.198 2.964-5.833 6.667-5.833"
  })));
};
export default SvgCommentHollow;